import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Router } from './router';

export function App() {
  return (
    <BrowserRouter>
      <Router />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 3000,
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </BrowserRouter>
  );
}
